export default __webpack_public_path__ + "static/media/laravel.f3ad6dc3.png";